var map = {
	"./studywayIcon1.png": "c11a",
	"./studywayIcon2.png": "f7e0",
	"./studywayIcon3.png": "53a0",
	"./studywayIcon4.png": "5d67",
	"./studywayIcon5.png": "48e1",
	"./studywayIcon6.png": "0415",
	"./studywayIcon7.png": "680d",
	"./studywayIcon8.png": "3e15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4a8";